import { useState } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';

export default SortOrFilterBox; function SortOrFilterBox({ buttonName, filterBy, showNotif, list, handleApply, handleShowNotif }) {
    const { t } = useTranslation();
    const [data, setData] = useState('');

    const handleChange = async () => {
        handleApply(data);
    }

    const handleReset = async () => {
        setData('');
        handleApply('');
    }

    return (<>
        <div className="filter-or-sort-box">
            <button type="button" className={"button"} onMouseEnter={() => handleShowNotif()}>
                {
                    buttonName === 'Filter' ? (<>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.2116 5.61C6.2316 8.2 9.9616 13 9.9616 13V19C9.9616 19.55 10.4116 20 10.9616 20H12.9616C13.5116 20 13.9616 19.55 13.9616 19V13C13.9616 13 17.6816 8.2 19.7016 5.61C20.2116 4.95 19.7416 4 18.9116 4H5.0016C4.1716 4 3.7016 4.95 4.2116 5.61Z" fill="#003448" />
                        </svg>
                    </>) : (<>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.06719 4C8.15186 4 8.22176 4.02775 8.27618 4.08203C8.33035 4.1363 8.35723 4.20568 8.35723 4.29004V16.7617H10.0975C10.1822 16.7617 10.2521 16.7886 10.3065 16.8428C10.3606 16.8975 10.3875 16.9669 10.3875 17.0518C10.3875 17.1239 10.3572 17.1972 10.2967 17.2695L7.40606 20.1602C7.34568 20.2143 7.27562 20.2422 7.19708 20.2422C7.12458 20.2421 7.05548 20.2143 6.98907 20.1602L4.08868 17.2598C3.9982 17.1631 3.9768 17.0573 4.0252 16.9424C4.07359 16.8219 4.16414 16.7618 4.29669 16.7617H6.03692V4.29004C6.03692 4.20553 6.0647 4.1355 6.11895 4.08105C6.17317 4.02696 6.2427 4.00005 6.32696 4H8.06719ZM19.6688 17.9219C19.7534 17.9219 19.8233 17.9494 19.8777 18.0039C19.9318 18.0582 19.9589 18.1276 19.9588 18.2119V19.9521C19.9588 20.0368 19.9318 20.1057 19.8777 20.1602C19.8233 20.2145 19.7534 20.2422 19.6688 20.2422H12.1277C12.0433 20.2421 11.9741 20.2144 11.9197 20.1602C11.8655 20.1057 11.8377 20.0369 11.8377 19.9521V18.2119C11.8377 18.1275 11.8656 18.0582 11.9197 18.0039C11.9741 17.9494 12.0433 17.9219 12.1277 17.9219H19.6688ZM17.9285 13.2812C18.0131 13.2812 18.083 13.309 18.1375 13.3633C18.1915 13.4175 18.2186 13.4869 18.2186 13.5713V15.3115C18.2186 15.3959 18.1915 15.4653 18.1375 15.5195C18.083 15.5738 18.0131 15.6016 17.9285 15.6016H12.1277C12.0432 15.6015 11.9741 15.5738 11.9197 15.5195C11.8654 15.4653 11.8377 15.396 11.8377 15.3115V13.5713C11.8377 13.4868 11.8655 13.4176 11.9197 13.3633C11.9741 13.309 12.0432 13.2813 12.1277 13.2812H17.9285ZM16.1883 8.64062C16.2729 8.64062 16.343 8.66834 16.3973 8.72266C16.4514 8.77696 16.4783 8.84625 16.4783 8.93066V10.6709C16.4783 10.7556 16.4517 10.8255 16.3973 10.8799C16.3431 10.9343 16.2729 10.9609 16.1883 10.9609H12.1277C12.0434 10.9609 11.974 10.9339 11.9197 10.8799C11.8654 10.8255 11.8377 10.7556 11.8377 10.6709V8.93066C11.8377 8.84607 11.8655 8.77701 11.9197 8.72266C11.9741 8.66826 12.0432 8.64068 12.1277 8.64062H16.1883ZM14.4481 4C14.5327 4 14.6028 4.02775 14.657 4.08203C14.7113 4.13638 14.7381 4.20572 14.7381 4.29004V6.03027C14.7381 6.11468 14.7113 6.18393 14.657 6.23828C14.6028 6.29266 14.5327 6.32031 14.4481 6.32031H12.1277C12.0433 6.32024 11.9741 6.2925 11.9197 6.23828C11.8655 6.1839 11.8377 6.11482 11.8377 6.03027V4.29004C11.8377 4.20553 11.8655 4.1355 11.9197 4.08105C11.974 4.02695 12.0434 4.00007 12.1277 4H14.4481Z" fill="#003448" />
                        </svg>

                    </>)
                }
                <span>{t(buttonName)}</span>
            </button>
            {
                showNotif && (<>
                    <div className="notification" onMouseLeave={() => handleShowNotif()}>
                        <div className="arrows"></div>
                        <div className="box">
                            {
                                buttonName === 'Filter' && <span className='filter-by'>{t(filterBy)}</span>
                            }
                            <select className='form-control' value={data} onChange={(e) => setData(e.target.value)}>
                                {
                                    buttonName === 'Filter' ? <option value=''>{t('Select ' + filterBy)}</option> : <option value=''>{t('Select Sort Type')}</option>
                                }
                                {
                                    list?.map((item) => (<>
                                        <option value={item.value}>{item.label}</option>
                                    </>))
                                }
                            </select>
                            <div className="btn-box">
                                <button
                                    type="button"
                                    style={{ float: 'right', marginRight: '10px' }}
                                    className="ApplyBtn btn btn-outline-next"
                                    onClick={() => handleChange()}
                                >
                                    {t("Apply")}
                                </button>
                                <button
                                    type="button"
                                    style={{ float: 'right' }}
                                    className="ResetBtn btn btn-outline-theme"
                                    onClick={() => handleReset()}
                                >
                                    {t("Reset")}
                                </button>
                            </div>
                        </div>
                    </div>
                </>)
            }
        </div >
    </>);
}